module.exports = __webpack_public_path__ + "img/icon-Clock.5eeccdfd.svg";